/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_Skill_Group_CountInputs */

const en_tables_skill_groups_skill_group_count = /** @type {(inputs: Tables_Skill_Groups_Skill_Group_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups Skill Group Count`)
};

const de_tables_skill_groups_skill_group_count = /** @type {(inputs: Tables_Skill_Groups_Skill_Group_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Skill-Gruppen`)
};

/**
* | output |
* | --- |
* | "Groups Skill Group Count" |
*
* @param {Tables_Skill_Groups_Skill_Group_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_skill_group_count = /** @type {((inputs?: Tables_Skill_Groups_Skill_Group_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_Skill_Group_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_skill_group_count(inputs)
	return de_tables_skill_groups_skill_group_count(inputs)
});